import {fetch, normalize} from "utils/dataAccess";
import {WmsTaskStatus} from "../../../utils/WMSTaskStatus";

export function getTasks(currentInventory, memberId = null, status = [WmsTaskStatus.IDLE, WmsTaskStatus.IN_PROGRESS]) {
    const params = new URLSearchParams();

    if (memberId) {
        params.append('member.id', memberId);
    }

    params.append('inventoryId', currentInventory.id);

    if (status.length > 0) {
        for (const stat of status) {
            params.append('status[]', stat)
        }
    }

    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_tasks?` + params.toString())
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved['hydra:member'])
                })
            })
            .catch(error => reject(error));
    });
}

export function getTaskWithModel(modelId) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_tasks/model/" + modelId)
            .then(response => {
                response.json().then(retrieved => {
                    Object.keys(retrieved).length === 0 ? resolve(null) : resolve(retrieved);
                })
            })
            .catch(error => reject(error));
    });
}


export function createTaskWithModel (modelId, memberId) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_tasks/createWithModel/", {
            method: "POST",
            body: JSON.stringify({modelId: modelId, memberId: memberId})
        })
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function patchTaskStarted(task, member, containerCodebar = null) {
    let body = {member : "/members/" + member.id}
    if (containerCodebar) {
        body.containerCodebar = containerCodebar
    }

    return new Promise((resolve, reject) => {
        let errorBody = null;

        fetch(
            "/w_m_s_tasks/start/" + task,
            {
                method: "PATCH",
                headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
                body: JSON.stringify(body)
            },
            false,
            true,
            (json) => { errorBody = json }
        )
            .then(response => {
                response.json().then(retrieved => {
                    resolve(normalize(retrieved))
                })
            })
            .catch(() => reject(errorBody));
    });
}

export async function getTask(taskId) {
    const response = await fetch(`/w_m_s_tasks/${taskId}`);

    if (!response.ok) {
        throw new Error(`Failed to retrieve task with ID ${taskId}: ${response.statusText}`);
    }

    return  await response.json();
}
